import React from 'react'
import shareButtonMobile from "share_button_mobile.png"
import ShareButton from "./share_button";
import {useTracking} from "../../effects/use_tracking";

export default function ShareButtons({trackingSource, shareUrl, shareTitle, shareText, mobileShareButtonImage, disableNavigatorShare}) {
  const track = useTracking()
  const isNavigatorShareEnabled = disableNavigatorShare !== true && disableNavigatorShare !== "true" && !!navigator.share

  const enabled_shareTypes = [
    "Facebook",
    "Whatsapp"
  ];

  const mobileShare = (url, title, text) => {
    const shareData = {}

    if (url) {
      shareData["url"] = url;
    }
    if (title) {
      shareData["title"] = title;
    }
    if (text) {
      shareData["text"] = text;
    }


    navigator.share(shareData)
      .then(() => {
        track(trackingSource, {description: url}, {event_label: url})
      })
      .catch((error) => console.log('Sharing failed', error));
  }

  if (isNavigatorShareEnabled) {
    return <img src={mobileShareButtonImage || shareButtonMobile}
                className="img-fluid"
                style={{
                  cursor: "pointer",
                  maxHeight: "80px"
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  mobileShare(shareUrl, shareTitle, shareText)
                }}/>;
  }

  const shareButtonAdditionalInfo = {}

  if (shareTitle && shareText) {
    shareButtonAdditionalInfo["quote"] = `${shareTitle}\n\n${shareText}`;
  } else if (shareTitle) {
    shareButtonAdditionalInfo["quote"] = shareTitle;
  } else if (shareText) {
    shareButtonAdditionalInfo["quote"] = shareText;
  }

  if (shareTitle) {
    shareButtonAdditionalInfo["title"] = shareTitle;
    shareButtonAdditionalInfo["subject"] = shareTitle;
  }

  if (shareText) {
    shareButtonAdditionalInfo["body"] = shareText;
    shareButtonAdditionalInfo["description"] = shareText;
    shareButtonAdditionalInfo["summary"] = shareText;
  }

  console.log("shareButtonAdditionalInfo", shareButtonAdditionalInfo)

  return <div className={""} onClick={(e) => e.stopPropagation() }>
    {enabled_shareTypes.map((type) => {
      return <div style={{paddingRight: "5px", display: "inline"}}>
        <ShareButton key={type}
                     type={type}
                     info={shareButtonAdditionalInfo}
                     trackingSource={trackingSource}
                     url={shareUrl}/>
      </div>
    })}
  </div>;
}
